<div class="average-bar" [style.left]="moveRight"></div>
